import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';

export type CategoryListData = AnyObject

export type CategoryListResponse = CategoryListData

export type CategoryListParams = PaginationProps

export const categoryList = (payload: CategoryListParams): Action<CategoryListParams> => ({
  type: actions.categoryListTrigger.toString(),
  payload,
});

export const categoryListClear = (): Action => ({
  type: actions.categoryListClear.toString(),
});

export const categoryListErrorClear = (): Action => ({
  type: actions.categoryListErrorReset.toString(),
});

export function* categoryListRequestSaga({ payload }: Action<CategoryListParams>) {
  yield put({
    type: actions.categoryListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.categoryListError.toString(),
      payload: {
        message: 'CategoryList: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}categories?${new URLSearchParams(payload).toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CategoryListData, CategoryListResponse>(
    response,
    actions.categoryListSuccess.toString(),
    actions.categoryListError.toString(),
    false,
    (categoryListData) => categoryListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.categoryListTrigger.toString(),
    defaultProcessingSaga(
      categoryListRequestSaga,
      {
        error: actions.categoryListError.toString(),
        locationCancel: actions.categoryListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.categoryListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.categoryListClear.toString(),
    // });
  });

  yield takeLatest(actions.categoryListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.categoryListErrorReset.toString(),
    });
  });
}
